<template>
  <div class="page-frame">
    <el-tabs class="page-tabs" :class="tabClass"
             v-model="tabsActiveName" type="card" @tab-remove="tabsRemove" @tab-click="tabsClick">
      <el-tab-pane v-for="(item, index) in tabsList" :key="item.name" :name="item.name" :closable="true" :lazy="true">
        <span slot="label">
          {{ item.title }}
        </span>
        <div class="iframe-container" v-loading="item.loading" element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0)">
          <iframe class="zwx-iframe" ref="zwxIframe" :src="item.content" frameborder="0"
                  :onload="iframeOnload(item, index)" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "PageFrame",
  props: ["tabClass"],
  data() {
    return {
      tabsActiveName: "",
      tabsList: [],
      ifTabsChange: true
    };
  },
  created() {

  },
  watch: {
    tabsList() {
      this.ifTabsChange = true;
    }
  },
  mounted() {
    this.tabsListen();
  },
  computed: {},
  methods: {
    tabsListen() {
      const pageTabsList = document.getElementsByClassName("page-tabs");
      if (pageTabsList === undefined || pageTabsList === null || pageTabsList.length === 0) return;
      this.$zwxBase.listenDocumentWH(pageTabsList[0].getElementsByClassName("el-tabs__nav"), this.tabsCallback);
    },
    tabsCallback() {
      if (!this.ifTabsChange) return;
      this.ifTabsChange = false;
      const pageTabsList = document.getElementsByClassName("page-tabs");
      if (pageTabsList === undefined || pageTabsList === null || pageTabsList.length === 0) return;
      const elTabsItem = pageTabsList[0].getElementsByClassName("el-tabs__item");
      for (let i = 0, length = elTabsItem.length; i < length; i++) {
        elTabsItem[i].onmouseup = event => this.mouseup(event, this.tabsList[i].name);
      }
    },
    mouseup(event, name) {
      if (event.which !== 2 || this.tabsList[0].name === name) return;
      this.tabsRemove(name);
    },
    tabsRemove(name) {
      let activeName = this.tabsActiveName;
      let index = -1;
      for (let i = 0, length = this.tabsList.length; i < length; i++) {
        if (this.tabsList[i].name === name) {
          activeName = this.tabsRemoveActive(name, activeName, i, length);
          index = i;
          break;
        }
      }
      if (index === -1) return;
      this.tabsActiveName = activeName;
      this.$emit("tabSelect", activeName);
      this.tabsList.splice(index, 1);
    },
    tabsRemoveActive(name, activeName, i, length) {
      if (activeName === name) {
        if (length > 1) {
          activeName = this.tabsList[i < length - 1 ? i + 1 : i - 1].name;
        } else {
          activeName = "home";
        }
      }
      return activeName;
    },
    tabsClick(tab) {
      this.$emit("tabSelect", tab.name);
    },
    menuTabs(name, title, content, refresh) {
      let index = -1;
      for (let i = 0, length = this.tabsList.length; i < length; i++) {
        if (this.tabsList[i].name === name) {
          index = i;
          break;
        }
      }
      if (index === -1) {
        this.tabsList.push({ name: name, title: title, content: content, loading: true });
      } else if (this.tabsActiveName === name || refresh) {
        this.tabsList[index].loading = true;
        this.$refs.zwxIframe[index].src = content;
        this.$refs.zwxIframe[index].contentWindow.location.reload(true);
      }
      this.tabsActiveName = name;
    },
    iframeOnload(item, index) {
      if (!item.loading) return;
      this.$nextTick(() => this.iframeOnloadNextTick(item, index));
    },
    iframeOnloadNextTick(item, index) {
      let iframe = this.$refs.zwxIframe[index];
      if (iframe.attachEvent) {
        this.iframeOnloadAttachEvent(item, iframe);
        return;
      }
      iframe.onload = () => {
        item.loading = false;
      };
    },
    iframeOnloadAttachEvent(item, iframe) {
      iframe.attachEvent("onload", () => {
        item.loading = false;
      });
    }
  }
};
</script>

<style lang="less">
.page-frame {
  position: relative;
  width: 100%;
  height: 100%;

  .invisible-tab {
    .el-tabs__header {
      display: none !important;
    }

    .el-tabs__content {
      top: 0 !important;
      background: unset !important;
    }

    .iframe-container {
      margin-top: 10px !important;
    }
  }
}
</style>
